import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ISemesterNotificationContext } from '@lb/api/mylb/interfaces';
import { NotificationBaseComponent } from './notification-base/notification-base.component';

/**
 * Learner notification: the semester final grade has been submitted.
 * `data` is the hydrated SemesterNotificationContext; EntityID is the SemesterID.
 */
@Component({
	standalone: true,
	imports: [CommonModule, NotificationBaseComponent],
	selector: 'lb-notification-semester-grades-available',
	template: `<lb-notification-base [notification]="notification()">
		<div activity-message>
			Your final grade for <b>Semester {{ context()?.levelName }}</b> is available.
			@if (context()?.finalGradeName) {
				<br />
				Grade: <b>{{ context()?.finalGradeName }}</b>
			}
		</div>
		<div activity-action>
			@if (context()) {
				<button type="button" md-button (click)="viewGrade()">View Grade</button>
			}
		</div>
	</lb-notification-base>`,
	styleUrls: ['./notification-base-shared.component.scss']
})
export class NotificationSemesterGradesAvailableComponent extends NotificationBaseComponent {
	private readonly _router = inject(Router);

	context = computed(() => this.notification().data as ISemesterNotificationContext);

	viewGrade(): void {
		const context = this.context();
		if (!context) {
			return;
		}
		this._router.navigate(['/enrollments', context.enrollmentID]);
	}
}
